module.exports = __webpack_public_path__ + "screenshot.93240a0d52984987bb94956fb2729ebb.png";